import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=5bc24d60&scoped=true&"
import script from "./SidePanel.vue?vue&type=script&lang=js&"
export * from "./SidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=5bc24d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc24d60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc24d60')) {
      api.createRecord('5bc24d60', component.options)
    } else {
      api.reload('5bc24d60', component.options)
    }
    module.hot.accept("./SidePanel.vue?vue&type=template&id=5bc24d60&scoped=true&", function () {
      api.rerender('5bc24d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Common/SidePanel.vue"
export default component.exports